import { useEffect, useSyncExternalStore } from 'react';
import { useUiStore } from './ui.store';

const DARK_QUERY = '(prefers-color-scheme: dark)';

function subscribeSystem(cb: () => void) {
  const mq = window.matchMedia(DARK_QUERY);
  mq.addEventListener('change', cb);
  return () => mq.removeEventListener('change', cb);
}

/** Resolved theme ('light' | 'dark'), following the OS when the preference is 'system'. */
export function useResolvedTheme(): 'light' | 'dark' {
  const pref = useUiStore((s) => s.theme);
  const systemDark = useSyncExternalStore(
    subscribeSystem,
    () => window.matchMedia(DARK_QUERY).matches,
    () => false,
  );
  if (pref === 'system') return systemDark ? 'dark' : 'light';
  return pref;
}

/** Keeps the `dark` class on <html> in sync with the resolved theme. Mount once at the root. */
export function useApplyTheme(): void {
  const resolved = useResolvedTheme();
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', resolved === 'dark');
    root.style.colorScheme = resolved;
  }, [resolved]);
}
